/**
 * A leitura de valores monetários vive em `@vaptmenu/money`, compartilhada com
 * o painel. Aqui fica só o que é próprio da página de preços.
 */

/** Meses grátis do anual em relação a 12 mensais, arredondado para baixo. */
export function freeMonths(monthly: number, yearly: number): number {
  if (monthly <= 0) return 0;
  return Math.max(0, Math.floor(12 - yearly / monthly));
}
